export class Course {
    Code: string;
    Description: string;
    ShortDescription: string;
    NumberOnly: number;

    static Sort(courses : Course[]) : Course[] {
      return courses.sort((a,b) => a.NumberOnly - b.NumberOnly);
    }
  }